const BASE_LOCALES = [
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'et',
    'fi',
    'fr',
    'hr',
    'hu',
    'it',
    'lt',
    'lv',
    'nb',
    'nl',
    'pl',
    'pt',
    'ro',
    'sk',
    'sl',
    'sv',
];

export const mapLocaleToBaseLocale = (locale: string): string => {
    if (BASE_LOCALES.includes(locale)) {
        return locale;
    }
    if (BASE_LOCALES.includes(locale.split('-')[0])) {
        return locale.split('-')[0];
    }
    return 'en';
};
